import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetUser {
	uriParams: Api.Operations['getUser']['parameters']['path']
	response: Api.Operations['getUser']['responses']['200']['content']['application/json']
}

export const getUser = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetUser>(
		{
			method: 'get',
			url: '/users/{userId}',
			...overideConfig,
		},
		axiosInstance,
	)
